export default "__VITE_ASSET__6fe1ecf4__"